// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2pjR6","inner":"Footer_inner__9lHfS"};